import script from "./ClipboardCopy.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClipboardCopy.vue?vue&type=script&setup=true&lang=ts"

import "./ClipboardCopy.vue?vue&type=style&index=0&id=be3d018e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be3d018e"]])

export default __exports__